import { render, staticRenderFns } from "./liveeventDashboard.vue?vue&type=template&id=4bcf4897&lang=true"
import script from "./liveeventDashboard.vue?vue&type=script&lang=js"
export * from "./liveeventDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports